import React, { Component } from "react";
import { connect } from "react-redux";
import { Column, Row } from "simple-flexbox";
import { StyleSheet, css } from "aphrodite";
import SelectComponent from "../form/SelectComponent";
import MonetizationOnIcon from "@material-ui/icons/MonetizationOn";
import NumberFormat from "react-number-format";
import { listSHU } from "../../actions/dashboard/koperasi_action";
import {
  getSHUData,
  getSHUPending,
  getSHUError,
} from "../../reducers/dashboard/koperasi_reducer";
import DatePicker from 'react-date-picker';
import DateFnsUtils from "@date-io/date-fns";
import {
  MuiPickersUtilsProvider,
  KeyboardDatePicker,
} from "@material-ui/pickers";
import moment from "moment";
import { dashboardGridStyles as grid } from
  "./dashboardGridStyles";


class CardKoperasiCash extends Component {
  state = {
    year: new Date().getFullYear(),
    start_date: moment(new Date(new Date().getFullYear(), 0, 1)).format('yyyy-MM-DD'),
    end_date: moment(new Date(new Date().getFullYear(), 11, 31)).format('yyyy-MM-DD'),
  };

  onYearChange = (year) => {
    const { listSHU } = this.props;
    const yearSelected = year ? year : new Date().getFullYear();
    this.setState({ year: yearSelected });
    listSHU({ year: yearSelected });
  };

  componentDidMount() {
    const { listSHU } = this.props;
    const { year } = this.state;
    let param = { start_date: this.state.start_date,
      end_date: this.state.end_date
};
    // listSHU({ year: year });
    listSHU(param);
  }
  handleStartDateChange = (e) =>{
    const { listSHU } = this.props;
    const date = moment(e).format('yyyy-MM-DD');
    if (e) {
      this.setState({ start_date: date });
    } else {
      this.setState({ start_date: null });
    }
    let param = { start_date: date,
      end_date: this.state.end_date
    };
    listSHU(param);
  }

  handleEndDateChange = (e) => {
    const { listSHU } = this.props;
    const date = moment(e).format('yyyy-MM-DD');
    if (e) {
      this.setState({ end_date: date });
    } else {
      this.setState({ end_date: null });
    }
    let param = { start_date: this.state.start_date,
      end_date: date
    };
    listSHU(param);
  }
  

  render() {
    const { listSHU_data } = this.props;
    const { year } = this.state;
    let total_shu = null;
    let total_member_shu = null;
    if (listSHU_data) {
      total_shu = listSHU_data[0].total_shu || 0;
      total_member_shu = listSHU_data[0].total_member;
    }
    let currentYear = new Date().getFullYear();
    let yearOptions = [];
    for (let i = currentYear; i >= 2019; i--) {
      yearOptions = [...yearOptions, { label: i, value: i }];
    }
    return (
      <div className={css(grid.col33)}>
        <Column
          style={{
            width: "100%",
            boxShadow: "0px 3px 6px #00000029",
            borderBottomLeftRadius: 5,
            borderBottomRightRadius: 5,
          }}
        >
          <div className={css(styles.cardHeader)}></div>
          <Row
            className={css(styles.wrapperTop, styles.borderBottom)}
            style={{ width: "100%" }}
            vertical="center"
          >
            <Row
              vertical="center"
              horizontal="center"
              style={{
                height: 48,
                width: 48,
                backgroundColor: "#45A3E7",
                borderRadius: 8,
                marginRight: 20,
              }}
            >
              <MonetizationOnIcon style={{ fontSize: 28, color: "#C6E7F8" }} />
            </Row>
            <div style={{}}>
              <label className={css(styles.titleLabel)}>
                {" "}
                Total SHU
                <br /> yang Dibagikan
              </label>
            </div>
          </Row>
          <Column
            className={css(styles.wrapper, styles.borderBottom)}
            style={{ width: "100%", padding: 20 }}
          >
            {/* <div
              style={{ margin: "auto", padding: "12px 40px", width: "100%" }}
            >
              <SelectComponent
                options={yearOptions}
                isRounded
                placeholder="Pilih tahun"
                defaultValue={{ value: year, label: year }}
                onChange={(e) => this.onYearChange(e?.value)}
              />
            </div> */}
            <Row style={{ width: "100%" }} wrap>
            <div
                style={{ margin: "auto", padding: "12px 5px", width: "50%" }}
              >
              <MuiPickersUtilsProvider utils={DateFnsUtils} style={{ margin: 0 }}>
                    {/* Tanggal Awal */}
                <KeyboardDatePicker
                  margin="dense"
                  id="date-picker-dialog"
                  format="dd/MM/yyyy"
                  value={this.state.start_date}
                  KeyboardButtonProps={{
                    "aria-label": "change date",
                  }}
                  onChange={(e) => this.handleStartDateChange(e)}
                />
              </MuiPickersUtilsProvider>
              </div>
              <div
                style={{ margin: "auto", padding: "12px 5px", width: "50%" }}
              >
                  <MuiPickersUtilsProvider utils={DateFnsUtils} style={{ margin: 0 }}>
                {/* Tanggal Awal */}
                    <KeyboardDatePicker
                      
                      margin="dense"
                      id="date-picker-dialog"
                      format="dd/MM/yyyy"
                      value={this.state.end_date}
                      KeyboardButtonProps={{
                        "aria-label": "change date",
                      }}
                      onChange={(e) => this.handleEndDateChange(e)}
                    />
                  </MuiPickersUtilsProvider>
              </div>
            </Row>
            <div
              style={{ fontSize: 24, fontWeight: "bold", textAlign: "center" }}
            >
              <NumberFormat
                thousandSeparator="."
                decimalSeparator=","
                prefix="Rp "
                displayType={"text"}
                value={total_shu}
              />
            </div>
            <div
              style={{ color: "#49505799", textAlign: "center", padding: 12 }}
            >
              {" "}
              Dibagikan ke{" "}
              <NumberFormat
                thousandSeparator="."
                decimalSeparator=","
                displayType={"text"}
                value={total_member_shu}
              />{" "}
              Anggota
            </div>
          </Column>
        </Column>
      </div>
    );
  }
}

const styles = StyleSheet.create({
  titleLabel: {
    color: "#495057",
    fontSize: 18,
    fontWeight: "bold",
    margin: "5px 0",
  },
  cardLabel: {
    color: "#495057",
    fontSize: 16,
    fontWeight: "bold",
    marginBottom: 4,
  },
  wrapper: {
    padding: 15,
    // height: 180
  },
  wrapperTop: {
    padding: 24,
    // height: 180
  },
  borderBottom: {
    borderBottom: "1px solid #eeee",
  },
  cardHeader: {
    backgroundColor: "#45A3E7",
    height: 10,
    width: "100%",
  },
});

function mapStateToProps({ listSHU }) {
  return {
    listSHU_data: getSHUData(listSHU),
    listSHU_error: getSHUError(listSHU),
    listSHU_pending: getSHUPending(listSHU),
  };
}

export default connect(mapStateToProps, { listSHU })(CardKoperasiCash);
